// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YNIca__layout {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  height: 100vh;
  padding: 0 1em 8em;
  background: var(--color-paper-2);

  z-index: 1000;
  overflow-y: auto;
}

.YNIca__layout .YhtU8__body a,.YNIca__layout article a {
    color: var(--color-blue-1);
    -webkit-text-decoration: underline;
    text-decoration: underline;
    text-underline-offset: 2px;
  }

.YNIca__layout .YhtU8__body a:hover,.YNIca__layout article a:not(.PceRR__does-not-exist):hover {
      opacity: 0.8;
    }

.rCC61__header {
  display: flex;
  align-items: center;
  gap: 0.8em;
}

.rCC61__header a {
    font-size: 1.5em;
    color: var(--color-blue-1);
  }

.rCC61__header h1 {
    margin: 0;
  }

.KvmTE__contentCard {
  max-width: 760px;
  margin: 0 auto;
}

/* ---------- feed ---------- */

.z3ms6__feed {
  display: grid;
  grid-gap: 2.5em;
  gap: 2.5em;
  margin-top: 1.5em;
}

.V3yZZ__post {
  /* Room for the fixed layout's top padding when scrolled to by anchor. */
  scroll-margin-top: 1em;
}

.V3yZZ__post .AzB90__postCard {
    text-align: left;
  }

.V3yZZ__post header h2 {
    margin: 0 0 1em;
    font-size: 1.5em;
  }

.V3yZZ__post header h2 a {
      color: inherit;
      -webkit-text-decoration: none;
      text-decoration: none;
    }

.V3yZZ__post header h2 a:hover {
        -webkit-text-decoration: underline;
        text-decoration: underline;
        text-underline-offset: 3px;
      }

.qFB01__postDate {
  display: block;
  font-size: 0.85em;
  opacity: 0.65;
  margin-bottom: 0.4em;
}

.hAymy__hero {
  display: block;
  width: 100%;
  height: auto;
  aspect-ratio: 3 / 2;
  object-fit: cover;
}

/* Post body: the markdown is rendered by \`marked\`, so these are element
   selectors on purpose. The tagline heading and the two section labels are
   uppercased with CSS only, matching the email the posts came from. */
.YhtU8__body {
  font-size: 1.05em;
  line-height: 1.65;
}
.YhtU8__body h2 {
    margin: 1.6em 0 0.6em;
    font-size: 1.2em;
  }
.YhtU8__body h2:first-child {
    margin-top: 0;
    font-family: var(--subheading-font);
    font-size: 1.15em;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }
.YhtU8__body p.label {
    margin-bottom: 0.25em;
    font-weight: 700;
    font-size: 0.9em;
    letter-spacing: 0.05em;
    text-transform: uppercase;
  }
.YhtU8__body hr {
    border: 0;
    border-top: 1px solid rgba(128, 128, 128, 0.25);
    margin: 1.6em 0;
  }
.YhtU8__body ul,.YhtU8__body ol {
    padding-left: 1.4em;
  }
.YhtU8__body li {
    margin: 0.35em 0;
  }
.YhtU8__body code {
    font-family: Menlo, Consolas, monospace;
    font-size: 0.9em;
    background: var(--color-paper-2);
    padding: 0.1em 0.4em;
    border-radius: 4px;
  }

.KzmiM__cta {
  margin: 1.75em 0 1.2em;
  text-align: center;
}

.cetmQ__ctaButton {
  display: inline-block;
  padding: 0.85em 2.5em;
  border-radius: 12px;
  background: var(--color-red-1, #ee3031);
  color: #fff !important;
  font-weight: 700;
  -webkit-text-decoration: none !important;
  text-decoration: none !important;
}

.hLKMN__ctaNote {
  margin: 0.9em 0 0;
  font-size: 0.85em;
  opacity: 0.75;
}

.hLKMN__ctaNote a {
    color: var(--color-blue-1);
  }
`, "",{"version":3,"sources":["webpack://./src/app/routes/news/NewsRoute.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;EACP,aAAa;EACb,kBAAkB;EAClB,gCAAgC;;EAEhC,aAAa;EACb,gBAAgB;AAYlB;;AAVE;IAEE,0BAA0B;IAC1B,kCAA0B;IAA1B,0BAA0B;IAC1B,0BAA0B;EAK5B;;AAHE;MACE,YAAY;IACd;;AAIJ;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;AAUZ;;AARE;IACE,gBAAgB;IAChB,0BAA0B;EAC5B;;AAEA;IACE,SAAS;EACX;;AAGF;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,+BAA+B;;AAE/B;EACE,aAAa;EACb,eAAU;EAAV,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,wEAAwE;EACxE,sBAAsB;AAoBxB;;AAlBE;IACE,gBAAgB;EAClB;;AAEA;IACE,eAAe;IACf,gBAAgB;EAWlB;;AATE;MACE,cAAc;MACd,6BAAqB;MAArB,qBAAqB;IAMvB;;AAJE;QACE,kCAA0B;QAA1B,0BAA0B;QAC1B,0BAA0B;MAC5B;;AAKN;EACE,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;sEAEsE;AACtE;EACE,iBAAiB;EACjB,iBAAiB;AA6CnB;AA3CE;IACE,qBAAqB;IACrB,gBAAgB;EAClB;AAEA;IACE,aAAa;IACb,mCAAmC;IACnC,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;EAC3B;AAEA;IACE,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;EAC3B;AAEA;IACE,SAAS;IACT,+CAA+C;IAC/C,eAAe;EACjB;AAEA;IAEE,mBAAmB;EACrB;AAEA;IACE,gBAAgB;EAClB;AAEA;IACE,uCAAuC;IACvC,gBAAgB;IAChB,gCAAgC;IAChC,oBAAoB;IACpB,kBAAkB;EACpB;;AAGF;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,mBAAmB;EACnB,uCAAuC;EACvC,sBAAsB;EACtB,gBAAgB;EAChB,wCAAgC;EAAhC,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;AAKf;;AAHE;IACE,0BAA0B;EAC5B","sourcesContent":[".layout {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  height: 100vh;\n  padding: 0 1em 8em;\n  background: var(--color-paper-2);\n\n  z-index: 1000;\n  overflow-y: auto;\n\n  & .body a,\n  & article a {\n    color: var(--color-blue-1);\n    text-decoration: underline;\n    text-underline-offset: 2px;\n\n    &:hover {\n      opacity: 0.8;\n    }\n  }\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  gap: 0.8em;\n\n  & a {\n    font-size: 1.5em;\n    color: var(--color-blue-1);\n  }\n\n  & h1 {\n    margin: 0;\n  }\n}\n\n.contentCard {\n  max-width: 760px;\n  margin: 0 auto;\n}\n\n/* ---------- feed ---------- */\n\n.feed {\n  display: grid;\n  gap: 2.5em;\n  margin-top: 1.5em;\n}\n\n.post {\n  /* Room for the fixed layout's top padding when scrolled to by anchor. */\n  scroll-margin-top: 1em;\n\n  & .postCard {\n    text-align: left;\n  }\n\n  & header h2 {\n    margin: 0 0 1em;\n    font-size: 1.5em;\n\n    & a {\n      color: inherit;\n      text-decoration: none;\n\n      &:hover {\n        text-decoration: underline;\n        text-underline-offset: 3px;\n      }\n    }\n  }\n}\n\n.postDate {\n  display: block;\n  font-size: 0.85em;\n  opacity: 0.65;\n  margin-bottom: 0.4em;\n}\n\n.hero {\n  display: block;\n  width: 100%;\n  height: auto;\n  aspect-ratio: 3 / 2;\n  object-fit: cover;\n}\n\n/* Post body: the markdown is rendered by `marked`, so these are element\n   selectors on purpose. The tagline heading and the two section labels are\n   uppercased with CSS only, matching the email the posts came from. */\n.body {\n  font-size: 1.05em;\n  line-height: 1.65;\n\n  & h2 {\n    margin: 1.6em 0 0.6em;\n    font-size: 1.2em;\n  }\n\n  & h2:first-child {\n    margin-top: 0;\n    font-family: var(--subheading-font);\n    font-size: 1.15em;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n  }\n\n  & :global(p.label) {\n    margin-bottom: 0.25em;\n    font-weight: 700;\n    font-size: 0.9em;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n  }\n\n  & hr {\n    border: 0;\n    border-top: 1px solid rgba(128, 128, 128, 0.25);\n    margin: 1.6em 0;\n  }\n\n  & ul,\n  & ol {\n    padding-left: 1.4em;\n  }\n\n  & li {\n    margin: 0.35em 0;\n  }\n\n  & code {\n    font-family: Menlo, Consolas, monospace;\n    font-size: 0.9em;\n    background: var(--color-paper-2);\n    padding: 0.1em 0.4em;\n    border-radius: 4px;\n  }\n}\n\n.cta {\n  margin: 1.75em 0 1.2em;\n  text-align: center;\n}\n\n.ctaButton {\n  display: inline-block;\n  padding: 0.85em 2.5em;\n  border-radius: 12px;\n  background: var(--color-red-1, #ee3031);\n  color: #fff !important;\n  font-weight: 700;\n  text-decoration: none !important;\n}\n\n.ctaNote {\n  margin: 0.9em 0 0;\n  font-size: 0.85em;\n  opacity: 0.75;\n\n  & a {\n    color: var(--color-blue-1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export var layout = `YNIca__layout`;
export var body = `YhtU8__body`;
var _1 = `PceRR__does-not-exist`;
export { _1 as "does-not-exist" };
export var header = `rCC61__header`;
export var contentCard = `KvmTE__contentCard`;
export var feed = `z3ms6__feed`;
export var post = `V3yZZ__post`;
export var postCard = `AzB90__postCard`;
export var postDate = `qFB01__postDate`;
export var hero = `hAymy__hero`;
export var cta = `KzmiM__cta`;
export var ctaButton = `cetmQ__ctaButton`;
export var ctaNote = `hLKMN__ctaNote`;
export default ___CSS_LOADER_EXPORT___;
